export default function MySQL_DATATYPES() {
  return (
    <div>
      <h2>MySQL_DATATYPES</h2>    </div>
  );
}